import has from "lodash/has";

const API_NAME = "rota";
const API_VERSION = "/v1";
const CONTENT_TYPE = "application/vnd.coactive.rota-oncall+json";
const MAX_PAGE_SIZE = 200;

const actions = {
  async getRotaOncall(context, params) {
    return this.$api.get(API_NAME, `${API_VERSION}/rota-oncall/${params.id}`);
  },

  async getRotaOncalls(context, payload) {
    const myInit = {};
    myInit.queryStringParameters = { pageSize: MAX_PAGE_SIZE };
    // payload contains filter/sort options.
    if (payload) {
      if (has(payload, "sortBy")) {
        let sortField = payload.sortBy;
        if (sortField === "dateCreated") {
          sortField = "_id";
        }
        let sortOrder = 1;
        if (has(payload, "sortDesc") && payload.sortDesc === true) {
          sortOrder = -1;
        }
        myInit.queryStringParameters.sort = JSON.stringify({
          [sortField]: sortOrder,
        });
      }

      if (has(payload, "filter")) {
        myInit.queryStringParameters.filter = JSON.stringify(payload.filter);
      }
    }
    return this.$api
      .get(API_NAME, `${API_VERSION}/rota-oncall`, myInit)
      .then((response) => {
        if (has(response, "_embedded.rota-oncall")) {
          return response;
        }
        return false;
      });
  },
  async getAllRotaOncalls(context, payload) {
    const myInit = {};
    myInit.queryStringParameters = { pageSize: MAX_PAGE_SIZE };
    // payload contains filter/sort options.
    if (payload) {
      if (has(payload, "sortBy")) {
        let sortField = payload.sortBy;
        if (sortField === "dateCreated") {
          sortField = "_id";
        }
        let sortOrder = 1;
        if (has(payload, "sortDesc") && payload.sortDesc === true) {
          sortOrder = -1;
        }
        myInit.queryStringParameters.sort = JSON.stringify({
          [sortField]: sortOrder,
        });
      }

      if (has(payload, "filter")) {
        myInit.queryStringParameters.filter = JSON.stringify(payload.filter);
      }
    }
    return this.$api
      .getAllPages(API_NAME, `${API_VERSION}/rota-oncall`, myInit)
      .then((response) => {
        if (has(response, "_embedded.rota-oncall")) {
          return response;
        }
        return false;
      });
  },
  async createRotaOncall(context, rotaOncall) {
    const myInit = {
      headers: {
        Accept: CONTENT_TYPE,
      },
      body: rotaOncall,
    };

    return this.$api
      .doNotCatchIfError()
      .post(API_NAME, `${API_VERSION}/rota-oncall`, myInit);
  },
  async updateRotaOncall(context, params) {
    const myInit = {
      headers: {
        Accept: CONTENT_TYPE,
      },
      body: params.changes,
    };

    return this.$api.patch(
      API_NAME,
      `${API_VERSION}/rota-oncall/${params.id}`,
      myInit,
    );
  },

  async deleteRotaOncall(context, params) {
    return this.$api.del(API_NAME, `${API_VERSION}/rota-oncall/${params.id}`);
  },
};

export default {
  namespaced: true,
  actions,
};
